<template lang="pug">
.take-max-height
    Error(:code="404" message="Page Not Found")
</template>

<script>
import Error from '@/components/Error'

export default {
    components: { Error },
    name: 'PageNotFound',
}
</script>

<style lang="sass" scoped>
    .take-max-height
        height: 50vh
        min-height: 100%
</style>
